import { defineMessages } from 'react-intl';

const translations = {
  title: {
    id: 'pages.settings.general.transferSettings.title',
    defaultMessage: 'Transfer settings',
    description: 'title of the allocation settings on the configuration page',
  },
  feedback: {
    transferSettingsUpdated: {
      id: 'pages.settings.general.transferSettings.feedback.transferSettingsUpdated',
      defaultMessage: 'Transfer settings saved',
      description: 'feedback on the successful update of the transfer settings',
    },
    transferSettingsNotUpdated: {
      id: 'pages.settings.general.transferSettings.feedback.transferSettingsNotUpdated',
      defaultMessage: 'Transfer settings could not be saved',
      description: 'feedback on the failed update of the transfer settings',
    },
  },
  editDrawer: {
    title: {
      id: 'pages.settings.general.transferSettings.editDrawer.title',
      defaultMessage: 'Edit transfer settings',
      description: 'title of the edit transfer settings drawer',
    },
    inboundField: {
      label: {
        id: 'properties.inboundLocation',
        defaultMessage: 'Inbound location',
        description: 'label of the inbound location field',
      },
    },
    collectionField: {
      label: {
        id: 'properties.collectionLocation',
        defaultMessage: 'Collection location',
        description: 'label of the collection location field',
      },
    },
    internalShippingMethodField: {
      label: {
        id: 'properties.internalShippingMethod',
        defaultMessage: 'Internal shipping method',
        description: 'label of the internal shipping method field',
      },
    },
    backOrderInboundLocationField: {
      label: {
        id: 'properties.backOrderInboundLocation',
        defaultMessage: 'Backorder inbound location',
        description: 'label of the backorder inbound location field',
      },
    },
  },
  actions: {
    edit: {
      id: 'actions.edit',
      defaultMessage: 'Edit',
      description: 'label of the edit button',
    },
  },
};

export default defineMessages(translations);
